import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ImgAndDetailsContainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "DetailsContainer" }
const _hoisted_4 = { class: "DeterminantType" }
const _hoisted_5 = { class: "DeterminantScore" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScoreNumberOnly = _resolveComponent("ScoreNumberOnly")!

  return (_ctx.calculationReady)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "MainDeterminantContainer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.incentiveClicked && _ctx.incentiveClicked(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", { src: _ctx.imageSource }, null, 8 /* PROPS */, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(_ctx.DeterminantTypeText), 1 /* TEXT */)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("a", { class: "DetailsLink" }, [
              _createElementVNode("p", null, [
                _createTextVNode("More Details "),
                _createElementVNode("i", { class: "lnr-arrow-right" })
              ])
            ], -1 /* HOISTED */))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ScoreNumberOnly, {
            class: "MainDeterminantScore",
            score: _ctx.determinantScore
          }, null, 8 /* PROPS */, ["score"])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}